// extracted by mini-css-extract-plugin
module.exports = {"fieldPairDialog":"CreateRelease_field-pair-dialog__1or_d"};